import { Context, useContext } from 'react';

export const useSafeContext = <T>(ctx: Context<T | null>): T => {
    const value = useContext(ctx);
    if (!value) throw new Error('You must use this context consumer hook inside a valid provider');
    return value;
};
